import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22c64ca6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reset-password" }
const _hoisted_2 = { class: "box-menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_reset_options = _resolveComponent("reset-options")!
  const _component_reset_password_component = _resolveComponent("reset-password-component")!
  const _component_new_password = _resolveComponent("new-password")!
  const _component_reset_password_success = _resolveComponent("reset-password-success")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn--reset-pass-exit",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleModal')))
      }, " X "),
      false
        ? (_openBlock(), _createBlock(_component_reset_options, { key: 0 }))
        : _createCommentVNode("", true),
      (
          !$setup.emailHasBeenSent && !_ctx.$route.params.token && !_ctx.$route.params.resetBy
        )
        ? (_openBlock(), _createBlock(_component_reset_password_component, {
            key: 1,
            onToggleModal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggleModal'))),
            onRecoverByDocument: _cache[2] || (_cache[2] = ($event: any) => ($setup.recoverPasswordByDocument($event))),
            onRecoverByEmail: _cache[3] || (_cache[3] = ($event: any) => ($setup.recoverPasswordByEmail($event)))
          }))
        : (_ctx.$route.params.token)
          ? (_openBlock(), _createBlock(_component_new_password, {
              key: 2,
              onToggleModal: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('toggleModal')))
            }))
          : ($setup.emailHasBeenSent)
            ? (_openBlock(), _createBlock(_component_reset_password_success, {
                key: 3,
                onToggleModal: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('toggleModal')))
              }))
            : _createCommentVNode("", true)
    ])
  ]))
}